import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  circlesContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: 8,
    marginBottom: 8
  }
})

export default useStyles
